import { format, isToday, isTomorrow, startOfDay } from "date-fns";

/** Display label for shift proximity on job cards. */
export function formatShiftDateLabel(shiftDate: string): string {
  const date = startOfDay(new Date(shiftDate));
  if (isToday(date)) return "Tonight";
  if (isTomorrow(date)) return "Tomorrow";
  return format(date, "EEE, MMM d");
}

/** Optional urgency pill for today/tomorrow shifts. */
export function shiftUrgencyPill(shiftDate: string): string | null {
  const date = startOfDay(new Date(shiftDate));
  if (isToday(date)) return "Tonight";
  if (isTomorrow(date)) return "Tomorrow";
  return null;
}
